import styled from 'styled-components';
import { Container } from 'react-awesome-styled-grid';
import { media } from '../mediaUtils';

export const PageWrapUAM = styled(Container)`
  ${media.lessThan('md')`
    min-width: 100%;
    padding-left: 0;
    padding-right: 0;
    font-size: ${(p) => p.theme.fontSm};
    .createInstructorAccount {
      margin-left: 0;
      padding-left: 0;
    }
  `}
  ${media.greaterThan('md')`
    font-size: ${(p) => p.theme.fontSm};
    width: 100%;
    font-size: 15px;
  `}
  min-height: 100%;
  box-sizing: border-box;
  font-family: ${(p) => p.theme.fontFamily};
  background-color: ${(p) => p.theme.very_light_gray};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  a, a:visited {
    text-decoration: underline;
    color: rgb(3, 0, 165);
  }
  .logo {
    width: 100%;
  }
  > div {
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .loginError {
    background-color: ${(p) => p.theme.very_light_red};
    border: 1px solid ${(p) => p.theme.light_red};
    hr {
      border-top: 1px solid ${(p) => p.theme.light_red};
    }
  }
  .loginMessage {
    text-align: left;
    font-size: ${(p) => p.theme.fontMd};
    border-radius: 3px;
    border: 1px solid ${(p) => p.theme.light_gray};;
    color: ${(p) => p.theme.dark_gray};
    padding: 10px;
    ul, li {
      -webkit-margin-start: 14px;
    }
    a, a:hover, a:focus, button {
      text-decoration: underline;
    }
    .textLink {
      color: ${(p) => p.theme.aqua};
      font-size: ${(p) => p.theme.fontMd}
      display: inline;
      background: none;
      border: none;
      background-color: inherit;
      margin: 0;
      padding: 0;
      width: auto;
    }
  }
  .checkboxLabel {
    margin-left: 8px;
  }
`;
